export const retro_mesh_shorts = {
  msrp: 39.99,
  infoLink: 'https://www.teamtriton.com/retro-shorts.html',
  items: [
    {
      number: 'MS99',
      hasModel: false,
    },
    {
      number: 'MS100',
      hasModel: false,
    },
    {
      number: 'MS101',
      hasModel: false,
    },
    {
      number: 'MS102',
      hasModel: false,
    },
    {
      number: 'MS103',
      hasModel: false,
    },
    {
      number: 'MS104',
      hasModel: false,
    },
    {
      number: 'MS105',
      hasModel: false,
    },
    {
      number: 'MS106',
      hasModel: false,
    },
    {
      number: 'MS107',
      hasModel: false,
    },
    {
      number: 'MS108',
      hasModel: false,
    },
    {
      number: 'MS109',
      hasModel: false,
    },
    {
      number: 'MS110',
      hasModel: false,
    },
    {
      number: 'MS111',
      hasModel: false,
    },
    {
      number: 'MS112',
      hasModel: false,
    },
    {
      number: 'MS113',
      hasModel: false,
    },
    {
      number: 'MS114',
      hasModel: false,
    },
    {
      number: 'MS115',
      hasModel: false,
    },
    {
      number: 'MS116',
      hasModel: false,
    },
    {
      number: 'MS117',
      hasModel: false,
    },
  ],
};
